import { ROUTES } from '../constants/routes';
import { getSubcategoryCoursesPath } from './categoryNav';

function getCategoryId(course) {
  return course?.category_id ?? course?.category?.id ?? null;
}

function getSubcategoryId(course) {
  return course?.subcategory_id ?? null;
}

function getSubjectId(course) {
  return course?.subject_id ?? null;
}

function getCategoryLabel(course) {
  const categoryName = course?.category_name || course?.category?.name || 'Courses';
  const subcategoryName = course?.subcategory_name || '';

  return subcategoryName ? `${categoryName} ${subcategoryName}`.trim() : categoryName;
}

export function buildCategoryBrowsePath(course) {
  const categoryId = getCategoryId(course);
  const subcategoryId = getSubcategoryId(course);
  if (!categoryId) return null;

  if (subcategoryId) {
    return getSubcategoryCoursesPath(categoryId, subcategoryId);
  }

  return `${ROUTES.COURSES_BROWSE}?category_id=${categoryId}`;
}

export function buildSubjectBrowsePath(course) {
  const categoryId = getCategoryId(course);
  const subjectId = getSubjectId(course);
  if (!categoryId || !subjectId) return null;

  const params = new URLSearchParams({
    category_id: String(categoryId),
    subject_id: String(subjectId),
  });

  const subcategoryId = getSubcategoryId(course);
  if (subcategoryId) {
    params.set('subcategory_id', String(subcategoryId));
  }

  return `${ROUTES.COURSES_BROWSE}?${params.toString()}`;
}

export function buildCourseBreadcrumbs(course) {
  if (!course) {
    return [{ label: 'Home', path: ROUTES.HOME }];
  }

  const categoryName = course.category_name || course.category?.name || 'Courses';
  const subcategoryName = course.subcategory_name || '';
  const subjectName = course.subject_name || 'Course';

  return [
    { label: 'Home', path: ROUTES.HOME },
    {
      label: getCategoryLabel(course),
      path: buildCategoryBrowsePath(course),
      state: {
        categoryName,
        subcategoryName,
      },
    },
    {
      label: subjectName.toUpperCase(),
      path: buildSubjectBrowsePath(course),
      state: {
        categoryName,
        subcategoryName,
      },
    },
    { label: course.title, path: null },
  ];
}

export function buildPlaylistBreadcrumbs(course, chapterTitle) {
  if (!course) {
    return [{ label: 'Home', path: ROUTES.HOME }];
  }

  const categoryName = course.category_name || course.category?.name || 'Courses';
  const subcategoryName = course.subcategory_name || '';
  const subjectName = course.subject_name || 'Course';

  const crumbs = [
    { label: 'Home', path: ROUTES.HOME },
    {
      label: getCategoryLabel(course),
      path: buildCategoryBrowsePath(course),
      state: {
        categoryName,
        subcategoryName,
      },
    },
    {
      label: subjectName.toUpperCase(),
      path: buildSubjectBrowsePath(course),
      state: {
        categoryName,
        subcategoryName,
      },
    },
    {
      label: course.title,
      path: ROUTES.COURSE_DETAIL(course.id),
    },
  ];

  if (chapterTitle) {
    crumbs.push({ label: chapterTitle, path: null });
  }

  return crumbs;
}
